import { z } from "zod"

export const CLUSTERS = [
    "Badafi",
    "Bagauda",
    "Bakori",
    "Balbelu",
    "Ballen Boyi",
    "Bauda",
    "Bebeji",
    "C Amarya",
    "Dakatsalle",
    "Dangora",
    "Dankargo",
    "Dansoshiya",
    "Durmaw",
    "Funtua",
    "Gabari",
    "Gajele",
    "Gargai",
    "Gida Gauda",
    "Gidan Bakwai",
    "Gwarmai",
    "Kargon Kuki",
    "Kasuwar Dogo",
    "Kirawa",
    "Kiru",
    "Kofa",
    "Kogo",
    "Kuidawa",
    "Kuki",
    "Kwanar Dangora",
    "Kwanar Gwamna",
    "Kyarana",
    "Mazara",
    "Nassarawa Kuki",
    "Rahama Gabas",
    "Ranka",
    "Rantan",
    "Tafoki",
    "Tariwa",
    "Tiga",
    "Tsamiyar Shawara",
    "Tsaudawa",
    "Tsiga",
    "Unguwar Mani",
    "Yako",
    "Yalwa",
    "Yan Alewa",
    "Yankara"
] as const;

export const CLUSTER_ENUM = z.enum(CLUSTERS);

export const LGAS = [
    "Bichi",
    "Bunkure",
    "Dawakin Tofa",
    "Garun Mallam",
    "Kura"
] as const;

export const LGAS_ENUM = z.enum(LGAS);

export const GENDERS = [
    "Male",
    "Female"
] as const;

export const GENDER_ENUM = z.enum(GENDERS);

export const ID_TYPES = [
    "Cooperative Card",
    "Driver License",
    "National ID",
    "Passport",
    "Voter Card"
] as const;

export const ID_TYPE_ENUM = z.enum(ID_TYPES);

export const COOPERATIVE_ROLES = [
    "Leader",
    "Member",
    "Treasurer",
    "Assistant",
    "Secretary"
] as const;

export const COOPERATIVE_ROLE_ENUM = z.enum(COOPERATIVE_ROLES);

export const COMMODITIES = [
    "Onion",
    "Pepper",
    "Tomato",
] as const;

export const COMMODITY_ENUM = z.enum(COMMODITIES);

export const INPUT_PACKAGES = [
    "ONION PACKAGE - OG",
    "ONION PACKAGE - IG",
    "PEPPER PACKAGE - OG",
    "PEPPER PACKAGE - IG",
    "TOMATO PACKAGE - OG",
    "TOMATO PACKAGE - IG",
] as const;

export const INPUT_PACKAGE_ENUM = z.enum(INPUT_PACKAGES);

export const STATES = [
    "Kano",
    "Katsina",
    "Kaduna"
] as const;

export const STATE_ENUM = z.enum(STATES);

export const PREVIOUSLY_USED_FOR = [
    "Maize",
    "Maize and Soy",
    "Maize and Cow Pea",
    "Sorghum",
    "Sorghum and Soy",
    "Sorghum and Cow Pea"
] as const;

export const PREVIOUSLY_USED_FOR_ENUM = z.enum(PREVIOUSLY_USED_FOR);

export const STATUS = [
    "pending",
    "synced",
    "unsynced",
    "partial-sync"
] as const;

export const STATUS_ENUM = z.enum(STATUS);


